<div class="admin-wizard-select admin-wizard-controls">
  {{combo-box
    value=this.wizardId
    content=this.wizardList
    onChange=(route-action "changeWizard")
    options=(hash none="admin.wizard.select")
  }}
</div>

{{wizard-message
  key=this.messageKey
  opts=this.messageOpts
  url=this.documentationUrl
  component="logs"
}}

<div class="admin-wizard-container">
  {{outlet}}
</div>